import { FullClientConfig } from '../types';
import howserService from './howserService';

const clientConfig: FullClientConfig = {
  howserService,
};

export default clientConfig;
